import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

interface MobileLayoutProps {
  children: React.ReactNode;
  title?: string;
  headerRight?: React.ReactNode;
  onBack?: () => void;
  hideNav?: boolean;
}

const NAV = [
  { to: '/dashboard', icon: '📊', label: 'Home' },
  { to: '/create',    icon: '＋',  label: 'New Bot' },
  { to: '/billing',   icon: '💳',  label: 'Billing' },
  { to: '/account',   icon: '👤',  label: 'Account' },
];

export default function MobileLayout({ children, title, headerRight, onBack, hideNav }: MobileLayoutProps) {
  const { pathname } = useLocation();
  const { isDark, toggle } = useTheme();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      minHeight: '100vh', background: 'var(--bg-page)',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      color: 'var(--text-primary)',
    }}>
      {/* Header */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 50,
        background: 'var(--bg-sidebar)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center',
        padding: '0 16px', height: '52px', gap: '12px',
        flexShrink: 0,
      }}>
        {onBack && (
          <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--text-primary)', fontSize: '20px', cursor: 'pointer', padding: '4px', lineHeight: 1 }}>
            ←
          </button>
        )}
        <div style={{ flex: 1, fontWeight: 700, fontSize: '16px', color: 'var(--text-primary)' }}>
          {title || 'autopilot'}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {headerRight}
          {/* Theme toggle */}
          <div onClick={toggle} style={{
            width: '36px', height: '20px', borderRadius: '10px',
            background: isDark ? 'var(--bg-element)' : '#5B4FE8',
            border: `1px solid ${isDark ? 'var(--border)' : '#4338ca'}`,
            position: 'relative', cursor: 'pointer', transition: 'background 0.25s', flexShrink: 0,
          }}>
            <div style={{
              position: 'absolute', top: '2px', left: isDark ? '2px' : '16px',
              width: '14px', height: '14px', borderRadius: '50%',
              background: isDark ? 'var(--text-faint)' : 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '8px', transition: 'left 0.25s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            }}>
              {isDark ? '🌙' : '☀️'}
            </div>
          </div>
        </div>
      </div>

      {/* Page content */}
      <div style={{ flex: 1, overflowY: 'auto', paddingBottom: hideNav ? 0 : '72px' }}>
        {children}
      </div>

      {/* Bottom nav */}
      {!hideNav && (
        <div style={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 50,
          background: 'var(--bg-sidebar)',
          borderTop: '1px solid var(--border)',
          display: 'flex', height: '64px',
        }}>
          {NAV.map(item => {
            const active = pathname.startsWith(item.to) || (item.to === '/dashboard' && pathname === '/');
            return (
              <Link key={item.to} to={item.to} style={{
                flex: 1, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center', gap: '3px',
                textDecoration: 'none', color: active ? '#5B4FE8' : 'var(--nav-item)',
                fontSize: '18px',
              }}>
                <span style={{ fontSize: item.icon === '＋' ? '22px' : '18px', lineHeight: 1 }}>{item.icon}</span>
                <span style={{ fontSize: '10px', fontWeight: active ? 700 : 400 }}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
